import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CheckinDeleteCompanionResultEffect } from './checkin-delete-companion-result.effect';
import { checkinDeleteCompanionResultReducer } from './checkin-delete-companion-result.reducer';
import {
  CHECKIN_DELETE_COMPANION_RESULT_STORE_NAME,
  CheckinDeleteCompanionResultState,
} from './checkin-delete-companion-result.state';

/** Token of the CheckinDeleteCompanionResult reducer */
export const CHECKIN_DELETE_COMPANION_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<CheckinDeleteCompanionResultState, Action>
>('Feature CheckinDeleteCompanionResult Reducer');

/** Provide default reducer for CheckinDeleteCompanionResult store */
export function getDefaultCheckinDeleteCompanionResultReducer() {
  return checkinDeleteCompanionResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(CHECKIN_DELETE_COMPANION_RESULT_STORE_NAME, CHECKIN_DELETE_COMPANION_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([CheckinDeleteCompanionResultEffect]),
  ],
  providers: [
    {
      provide: CHECKIN_DELETE_COMPANION_RESULT_REDUCER_TOKEN,
      useFactory: getDefaultCheckinDeleteCompanionResultReducer,
    },
  ],
})
export class CheckinDeleteCompanionResultStoreModule {
  public static forRoot<T extends CheckinDeleteCompanionResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinDeleteCompanionResultStoreModule> {
    return {
      ngModule: CheckinDeleteCompanionResultStoreModule,
      providers: [{ provide: CHECKIN_DELETE_COMPANION_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
